'use client';

import { c as _c } from "react/compiler-runtime";
import { allRequirementOptions } from '../../utils/requirementOptions';
import { type RouterOutputs } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import Button from '../common/Button';
import Input from './Input';
const getRequirementLabel = (requirement: string): string => {
  const reqInfo = allRequirementOptions.find(opt => opt.value === requirement);
  return reqInfo?.label || requirement;
};
type FactiiiSearchReturnDTO = RouterOutputs['search']['factiiis']['factiiis'][0];
type Props = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchResults: FactiiiSearchReturnDTO[];
  onSelect: (factiii: FactiiiSearchReturnDTO) => void;
  placeholder: string;
  label?: string;
  validateSelection?: (factiii: FactiiiSearchReturnDTO) => string | null;
  onValidationError?: (error: string) => void;
};
const FactiiiSearchDropdown = t0 => {
  const $ = _c(21);
  const {
    searchValue,
    onSearchChange,
    searchResults,
    onSelect,
    placeholder,
    label,
    validateSelection,
    onValidationError
  } = t0;
  let t1;
  if ($[0] !== onSearchChange || $[1] !== onSelect || $[2] !== onValidationError || $[3] !== validateSelection) {
    t1 = factiii => {
      if (validateSelection) {
        const error = validateSelection(factiii);
        if (error) {
          onValidationError?.(error);
          return;
        }
      }
      onSelect(factiii);
      onSearchChange("");
    };
    $[0] = onSearchChange;
    $[1] = onSelect;
    $[2] = onValidationError;
    $[3] = validateSelection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleSelect = t1;
  let t2;
  if ($[5] !== label) {
    t2 = label && <div className="mb-2"><label className="block text-sm font-emphasis text-textPrimary">{label}</label></div>;
    $[5] = label;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onSearchChange) {
    t3 = e => onSearchChange(e);
    $[7] = onSearchChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== placeholder || $[10] !== searchValue || $[11] !== t3) {
    t4 = <Input type="text" value={searchValue} onChange={t3} label={placeholder} />;
    $[9] = placeholder;
    $[10] = searchValue;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleSelect || $[14] !== searchResults || $[15] !== searchValue) {
    t5 = searchValue && searchResults.length > 0 && <div className="absolute z-50 mt-1 w-full rounded-lg border border-ds-border-standard bg-background-primary shadow-lg"><div className="max-h-48 space-y-1 overflow-y-auto p-2">{searchResults.map(factiii_0 => <div key={factiii_0.id} className="cursor-pointer rounded-lg border border-ds-border-standard bg-background-primary p-3 transition-all duration-200 hover:bg-background-light" onClick={() => handleSelect(factiii_0)}><div className="flex items-center gap-3"><Avatar factiiiAvatarKey={factiii_0.avatarKey} factiiiId={factiii_0.id} size={32} /><div className="flex-1"><h4 className="text-sm font-semibold text-textPrimary">{factiii_0.name}</h4>{factiii_0.description && <p className="mt-1 text-xs text-textSecondary">{factiii_0.description}</p>}{factiii_0.requirements && factiii_0.requirements.length > 0 && <div className="mt-2 flex flex-wrap gap-1">{factiii_0.requirements.slice(0, 3).map(_temp)}{factiii_0.requirements.length > 3 && <span className="text-xs text-textSecondary">+{factiii_0.requirements.length - 3} more</span>}</div>}</div><Button text="+ Add" variant="CLEAR" classNames="text-xs font-semibold text-primary hover:text-primary/80" /></div></div>)}{searchResults.length === 0 && <div className="p-4 text-center text-textSecondary">No factiiis found</div>}</div></div>;
    $[13] = handleSelect;
    $[14] = searchResults;
    $[15] = searchValue;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t5) {
    t6 = <div className="relative">{t2}{t4}{t5}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default FactiiiSearchDropdown;
function _temp(req, index) {
  return <span key={index} className="rounded px-2 py-1 text-xs font-emphasis text-primary">{getRequirementLabel(req)}</span>;
}